import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarV2ListItem from './VeltCommentsSidebarV2ListItem/VeltCommentsSidebarV2ListItem';
var VeltCommentsSidebarV2List = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2List.Item = VeltCommentsSidebarV2ListItem;
export default VeltCommentsSidebarV2List;
